import styled from "styled-components/macro";
import { listItems, selected } from "theme";

const ItemContainer = styled("div")`
  ${({
    theme: {
      colors: { divider },
    },
  }) => `
  border-bottom: 1px solid ${divider};
  background: none;
  margin-bottom: 0;
  border-radius: 0;
`}
  ${listItems}
  ${selected}
`;

export default ItemContainer;
